exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* I hid this when I realized it was messing up nav-pills; can't remember what it was intended to affect\n.nav .nav-item .nav-link {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  color: #111;\n}\n*/", ""]);

// exports
